import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useState } from 'react';

import { TimeConstants } from '../../../../constants/time';

const _DiaryShortsHelper = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const LOCAL_STORAGE_KEY = 'diaryShortsHelperLastShown';
    const TWENTY_FOUR_HOUR = TimeConstants.DAY;

    const lastShownTime = localStorage.getItem(LOCAL_STORAGE_KEY);
    const currentTime = new Date().getTime();

    const canShowCase =
      !lastShownTime || // 로컬스토리지에 저장된 것이 없거나
      currentTime - parseInt(lastShownTime) > TWENTY_FOUR_HOUR; // 저장된 시간 + 24시간 이후인경우

    if (canShowCase) {
      setShow(true);
      localStorage.setItem(LOCAL_STORAGE_KEY, currentTime.toString());
      setTimeout(() => setShow(false), 3_000); // 3초 후 사라짐
    }
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className={`top-center left-center fixed z-10 min-w-[246px] rounded-[100px] bg-black/70 px-10px py-12px`}
        >
          <h5 className="flex shrink-0 text-16px leading-6 text-white">
            아래에서 위로 화면을 밀어주세요 ⬆
          </h5>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default _DiaryShortsHelper;
